<div id="kt_header" class="header">
  <!--begin::Container-->
  <div class="container-fluid d-flex align-items-center flex-wrap justify-content-between" id="kt_header_container">
    <!--begin::Page title-->
    <div
      class="page-title d-flex flex-column align-items-start justify-content-center flex-wrap me-2 pb-5 pb-lg-0 pt-7 pt-lg-0"
      data-kt-swapper="true" data-kt-swapper-mode="prepend"
      data-kt-swapper-parent="{default: '#kt_content_container', lg: '#kt_header_container'}">
      <!--begin::Heading-->
      <span class="d-flex">
        <span *ngFor="let title of breadCrumbTitle; let isFirst = first; let isLast = last" [ngClass]="isFirst ? 'fw-bold fs-1': 'ms-1 fs-6 align-content-center pt-1'" class="text-gray-900 my-0">
          <ng-container *ngIf="!isFirst">/</ng-container> 
          {{ title | translate }}
        </span>
      </span>
      
      <!--end::Heading-->
    </div>
    <!--end::Page title=-->
    <!--begin::Wrapper-->
    <div class="d-flex d-lg-none align-items-center ms-n4 me-2">
      <!--begin::Aside mobile toggle-->
      <div class="btn btn-icon btn-active-icon-primary" id="kt_aside_toggle">
        <i class="ki-duotone ki-abstract-14 fs-1 mt-1">
          <span class="path1"></span>
          <span class="path2"></span>
        </i>
      </div>
      <!--end::Aside mobile toggle-->
      <!--begin::Logo-->
      <a class="d-flex align-items-center">
        <img alt="Logo" src="assets\images\logos\logo_mv_verde.png" class="h-30px mt-1" />
      </a>
      <!--end::Logo-->
    </div>
    <!--end::Wrapper-->
    <!--begin::Topbar-->
    <div class="d-flex align-items-center flex-shrink-0">
      <!--begin::Search-->
      <!-- <div id="kt_header_search" class="header-search d-flex align-items-center w-lg-250px"
        data-kt-search-keypress="true" data-kt-search-min-length="2" data-kt-search-enter="enter"
        data-kt-search-layout="menu" data-kt-search-responsive="lg" data-kt-menu-trigger="auto"
        data-kt-menu-permanent="true" data-kt-menu-placement="bottom-end"> -->
        <!--end::Tablet and mobile search toggle-->
        <!--begin::Form(use d-none d-lg-flex classes for responsive search)-->
        <!-- <form data-kt-search-element="form"
          class="d-none align-items-center d-lg-flex w-100 mb-5 mb-lg-0 position-relative" autocomplete="off"> -->
          <!--begin::Hidden input(Added to disable form autocomplete)-->
          <!-- <input type="hidden" /> -->
          <!--end::Hidden input-->
          <!--begin::Icon-->
          <!-- <i class="ki-duotone ki-magnifier fs-2 text-gray-700 position-absolute top-50 translate-middle-y ms-4">
            <span class="path1"></span>
            <span class="path2"></span>
          </i> -->
          <!--end::Icon-->
          <!--begin::Input-->
          <!-- <input type="text" class="form-control bg-transparent ps-13 fs-7 h-40px" name="search" value=""
            placeholder="{{'SEARCH' | translate}}" data-kt-search-element="input" /> -->
          <!--end::Input-->
          <!--begin::Spinner-->
          <!-- <span class="position-absolute top-50 end-0 translate-middle-y lh-0 d-none me-5"
            data-kt-search-element="spinner">
            <span class="spinner-border h-15px w-15px align-middle text-gray-500"></span>
          </span> -->
          <!--end::Spinner-->
          <!--begin::Reset-->
          <!-- <span
            class="btn btn-flush btn-active-color-primary position-absolute top-50 end-0 translate-middle-y lh-0 d-none me-4"
            data-kt-search-element="clear">
            <i class="ki-duotone ki-cross fs-2 fs-lg-1 me-0">
              <span class="path1"></span>
              <span class="path2"></span>
            </i>
          </span> -->
          <!--end::Reset-->
        <!-- </form> -->
        <!--end::Form-->
      <!-- </div> -->
      <!--end::Search-->
      <!--begin::Activities-->
      <div class="d-flex align-items-center ms-3 ms-lg-4">
        <!--begin::Menu toggle-->
        <a class="btn btn-icon btn-color-gray-700 btn-active-color-primary btn-outline w-40px h-40px" (click)="notificationClickHandler()"
           mat-button [matMenuTriggerFor]="alertMenu">
          <span *ngIf="newNotificationsFlag" class="notification-alert"></span>
          <i class="fa-duotone fa-solid fs-1" [ngClass]="newNotificationsFlag ? 'fa-bell-exclamation bell-sway' : 'fa-bell'"></i>
        </a>
        <!--end::Menu toggle-->
        <!--begin::Menu-->
        <mat-menu #alertMenu="matMenu" [xPosition]="'before'"
          class="mt-2 menu menu-sub menu-sub-dropdown menu-column rounded menu-title-gray-700 icon-mv menu-icon-gray-500 menu-active-bg menu-state-color fw-semibold pt-2 fs-base w-350px"
          data-kt-menu="true" data-kt-element="theme-mode-menu">
          <!--begin::Menu item-->
          <ng-container *ngIf="notificationAlerts.length > 0; else noNotifications">
            <div class="menu-item px-0 my-0 mv-alert" *ngFor="let notif of notificationAlerts">
              <a class="menu-link px-4 py-0">
                <div class="d-flex w-100 align-items-center py-2 px-2">
                  <div class="col-1 d-flex fs-1 justify-content-center">
                    <i class="fa-duotone fa-solid fa-circle-info"></i>
                  </div>
                  <div class="col-10 ps-2">
                    <span class="align-self-start fs-7" style="white-space: nowrap;">
                      <strong>{{ 'SUPPORT_REQUEST' | translate }}</strong>
                      <span class="ms-2 fs-8 pe-2 ps-1 fw-bold" style="border-radius: 5px; background-color: #A7CDB5;">
                        {{ notif.creationDate | date : 'dd/MM/YYYY' }} - {{ 'DATE_DIFF' | translate : { difference:
                        notif.dateDiff } }} {{ notif.dateDiffMetric | translate }}
                      </span>
                    </span>
                    <br>
                    <span class="align-self-end fs-8" style="color: #959493">{{ notif.body }}</span>
                  </div>
                </div>
              </a>
            </div>
          </ng-container>
          <ng-template #noNotifications>
            <div class="menu-item px-0 my-0">
              <div class="px-0 py-2 text-center justify-content-center text-muted">
                <span>
                  {{ 'NO_NOTIFICATIONS' | translate }}
                </span>
              </div>
            </div>
          </ng-template>
          
          <hr class="my-1">
          <div class="menu-item px-0 my-0">
            <a class="menu-link px-0 py-2 text-center justify-content-center">
              <span>
                <i></i>
              </span>
              <span>
                {{ 'SHOW_ALL' | translate }}
              </span>
            </a>
          </div>
          <!--end::Menu item-->
        </mat-menu>
        <!--end::Menu-->
      </div>
      <!--end::Activities-->
      <!--begin::Theme mode-->
      <div class="d-flex align-items-center ms-3 ms-lg-4">
        <!--begin::Menu toggle-->
        <a class="btn btn-icon btn-color-gray-700 btn-active-color-primary btn-outline w-40px h-40px" mat-button [matMenuTriggerFor]="userMenu">
          <i class="fa-duotone fa-solid fa-user fs-1"></i>
        </a>
        <!--end::Menu toggle-->
        <!--begin::Menu-->
        <mat-menu #userMenu="matMenu" [xPosition]="'before'"
          class="mt-2 menu menu-sub menu-sub-dropdown menu-column rounded menu-title-gray-700 icon-mv menu-icon-gray-500 menu-active-bg menu-state-color fw-semibold py-2 fs-base w-300px">
          <!--begin::Menu item-->
          <div class="menu-item px-3 my-0">
            <a class="menu-link px-3 py-2" [routerLink]="[ '/profile' ]">
              <span class="menu-icon icon-mv" data-kt-element="icon">
                <i class="fa-solid fa-duotone fa-user mv icon-text fs-2">
                </i>
              </span>
              <span class="menu-title">{{ 'MY_PROFILE' | translate }}</span>
            </a>
          </div>
          <!--end::Menu item-->
          <!--begin::Menu item-->
          <div class="menu-item px-3 my-0">
            <a class="menu-link px-3 py-2">
              <span class="menu-icon icon-mv" data-kt-element="icon">
                <i class="fa-duotone fa-solid fa-earth-europe mv fs-2"></i>
              </span>
              <span class="menu-title">{{ 'LANGUAGE' | translate }}</span>
              <span (click)="$event.stopPropagation(); matSelectComponent?.open()">
                <mat-select (selectionChange)="_languageService.changeLanguage($event.value)"
                  (openedChange)="matSelectMenuHandler($event)" [value]="selectedLanguageObject?.value"
                  panelClass="mw-fit" class="mw-fit" hideSingleSelectionIndicator>
                  <mat-select-trigger class="me-3">
                    <span> {{ (selectedLanguageObject?.name ?? '') | translate }} </span>
                    <mat-icon>
                      <img class="country-flag" [src]="selectedLanguageObject?.icon" alt="">
                    </mat-icon>
                  </mat-select-trigger>
                  <mat-option *ngFor="let language of _languageService.availableLanguages" value="{{language.value}}"
                    (click)="$event.stopPropagation()">
                    <mat-icon>
                      <img class="country-flag" [src]="language?.icon" alt="">
                    </mat-icon>
                    <span class="me-1">{{ language.name| translate }}</span>
                  </mat-option>
                </mat-select>
              </span>
            </a>
          </div>
          <hr>
          <!--end::Menu item-->
          <!--begin::Menu item-->
          <div class="menu-item px-3 my-0">
            <a class="menu-link px-3 py-0" (click)="signOut()">
              <span class="menu-title justify-content-center">
                {{ 'SIGN_OUT' | translate }}
                <i class="fa-duotone fa-solid fa-right-to-bracket fs-2 ms-2"></i>
              </span>
            </a>
          </div>
          <!--end::Menu item-->
        </mat-menu>
        <!--end::Menu-->
      </div>
      <!--end::Theme mode-->
      <div class="d-flex align-items-center ms-3 ms-lg-4">
        <!--begin::Drawer toggle-->
        <div class="btn btn-primary text-white" (click)="openTicketDialog()">
          {{ 'I_WANT_TO_BE_CONTACTED' | translate }}
        </div>
        <!--end::Drawer toggle-->
      </div>
    </div>
    <!--end::Topbar-->
  </div>
  <!--end::Container-->
</div>